import ConfigInterface from "@hostingbv/lib/src/ConfigInterface";

const isProduction = import.meta.env.PROD;

// The backend resolves the tenant from the request hostname, so "{hostname}" in an API URL is replaced by the
// hostname this app is opened on. Locally, localhost:3002 and fourfusion.localhost:3002 then talk to different tenants.
const withHostname = (url: string) => url.replace("{hostname}", window.location.hostname);

export const config: ConfigInterface = {
  isProduction,

  sentryDsn: import.meta.env.VITE_SENTRY_DSN ?? "",

  adminApiUrl: import.meta.env.VITE_ADMIN_API_URL ?? "/api/",
  careApiUrl: import.meta.env.VITE_CARE_API_URL ?? "/api/",
  // partnerApiUrl: 'http://localhost:8000/partner-api/',
  partnerApiUrl: withHostname(import.meta.env.VITE_PARTNER_API_URL ?? "/api/"),
  domainApiUrl: import.meta.env.VITE_DOMAIN_API_URL ?? `wss://${window.location.host}/domain-api/`,
};

